import { sendCustomEvent } from '@/utils/GA4-service'
import { sendEventToStatsig } from '@/utils/statsig'

window.addEventListener('click', (event) => {
  const target = event?.target as HTMLElement
  const eventLabel = target?.dataset?.eventLabel
  const eventValue = target?.dataset?.eventValue

  if (eventLabel) {
    const eventData = eventValue ? { event_value: eventValue } : undefined
    sendCustomEvent(eventLabel, eventData)
    sendEventToStatsig(eventLabel, eventData)
  }
})
